import React from 'react';
import XButton from '../shared/atoms/XButton';
import Button from '../shared/Button';

interface OwnershipTipModalProps {
  onClose: () => void;
  onCopy: () => Promise<void>;
  isLoading: boolean;
}

export default function OwnershipTipModal({ onClose, onCopy, isLoading }: OwnershipTipModalProps) {
  return (
    <div className="border-2 border-white px-[30px] pt-[60px] pb-[40px] flex flex-col gap-y-[30px] items-center">
      <XButton onClose={onClose} />
      <div>
        <p className="font-cardinalfruit text-[30px] leading-[31.5px] text-center">
          Want to make changes to this board?
        </p>
        <p className="font-cardinalfruit text-[30px] leading-[31.5px] text-center">
          Make a copy first!
        </p>
      </div>

      <Button onClick={onCopy} loading={isLoading}>
        COPY
      </Button>
    </div>
  );
}
